<template>
  <div
    class="tree-selector__item"
    :class="{ selected: item.selected }"
    :data-test="`graphics-sportradar-stat-${item.label.toLowerCase()}`"
  >
    <!-- Parent Field -->
    <template v-if="isCollapsible">
      <button
        class="tree-selector__item-label mb-2 tb-btn tb-btn-text block"
        :data-test="`graphics-sportradar-stat-collapseToggle-${item.label.toLowerCase()}`"

        @click.stop="onClick"
      >
        <span
          class="fas fa-chevron-down"
          :class="{ collapsed: isCollapsed }"
        />

        <span class="ml-2">
          {{ label }}
        </span>
      </button>

      <div v-if="!isCollapsed" class="ml-3">
        <tree-item
          v-for="(child, idx) in item.children"
          :key="idx"
          :item="child"
          :value="value"
          :is-filtered="isFiltered"
          @select="onSelectChild"
        />
      </div>
    </template>

    <!-- Root Selectable Field -->
    <template v-else>
      <button
        class="tree-selector__item-label mb-2 tb-btn tb-btn-text block"
        @click.stop="onClick"
      >
        {{ label }} <span v-if="item.selected" class="fas fa-check" />
      </button>
    </template>
  </div>
</template>

<script>

import { createReadableLabel } from '../../../../utils/helpers';

export default {
  name: 'TreeItem',

  props: {
    item: {
      type: Object,
      required: true,
    },

    isFiltered: {
      type: Boolean,
      required: false,
    },

    value: {
      type: String,
      required: true,
    },
  },

  emits: ['select'],
  inject: ['labels'],

  data() {
    return {
      collapsed: !this.item.selected,
    };
  },

  computed: {
    /**
    * Automatically uncollapse if searching. Otherwise use state.
    */
    isCollapsed() {
      return this.isFiltered ? false : this.collapsed;
    },

    label() {
      const label = this.item.label || this.item.key;
      return this.labels[label] || createReadableLabel(label);
    },

    // If item is NOT collapsible, then it's selectable
    isCollapsible() {
      return !!this.item?.children?.length;
    },
  },

  methods: {
    onClick() {
      if (this.isCollapsible) {
        this.toggleCollapse();
      } else {
        this.$emit('select', this.item.key);
      }
    },

    onSelectChild(keyPath) {
      // Reconstruct key as we pass up the select event
      this.$emit('select', `${this.item.key}.${keyPath}`);
    },

    toggleCollapse() {
      this.collapsed = !this.collapsed;
    },
  },
};
</script>
